var _path, _path2, _path3, _path4, _path5, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAudioEnabled(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 56,
    height: 40,
    viewBox: "0 0 56 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20 0.5H36C46.7696 0.5 55.5 9.23045 55.5 20C55.5 30.7696 46.7696 39.5 36 39.5H20C9.23045 39.5 0.5 30.7696 0.5 20C0.5 9.23045 9.23045 0.5 20 0.5Z",
    stroke: "url(#paint0_linear_4134_27427)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M18 20.124C18 14.5327 22.4771 10 27.9999 10C33.5228 10 37.9999 14.5327 37.9999 20.124L37.9999 25.3675C38.0002 26.1844 38.0004 26.7446 37.8568 27.2364C37.576 28.1982 36.9046 28.9937 36.01 29.4245C35.5525 29.6449 35.0059 29.732 34.2088 29.8591L34.0789 29.8799C33.7954 29.9252 33.5532 29.9639 33.3522 29.9839C33.1431 30.0047 32.9299 30.0111 32.7118 29.9676C31.9942 29.8245 31.4024 29.3126 31.1508 28.6172C31.0744 28.4059 31.0474 28.1916 31.035 27.9793C31.0232 27.7753 31.0232 27.527 31.0232 27.2365L31.0231 23.0641C31.0226 22.6386 31.0222 22.2725 31.1195 21.959C31.3422 21.2416 31.9238 20.6975 32.6477 20.5292C32.9641 20.4556 33.3246 20.4849 33.7435 20.5189L33.8367 20.5264L33.9465 20.5352C34.7302 20.5975 35.2664 20.6402 35.7216 20.8106C36.0415 20.9304 36.3381 21.0953 36.6046 21.2976V20.124C36.6046 15.3129 32.7521 11.4127 27.9999 11.4127C23.2478 11.4127 19.3953 15.3129 19.3953 20.124V21.2976C19.6618 21.0953 19.9584 20.9304 20.2783 20.8106C20.7335 20.6402 21.2696 20.5975 22.0534 20.5352L22.1632 20.5264L22.2564 20.5189C22.6753 20.4849 23.0358 20.4556 23.3522 20.5292C24.0761 20.6975 24.6577 21.2416 24.8804 21.959C24.9777 22.2725 24.9773 22.6386 24.9768 23.0641L24.9767 27.2365C24.9767 27.527 24.9767 27.7753 24.9649 27.9793C24.9525 28.1916 24.9255 28.4059 24.8491 28.6172C24.5975 29.3126 24.0057 29.8245 23.2881 29.9676C23.07 30.0111 22.8568 30.0047 22.6477 29.9839C22.4467 29.9639 22.2045 29.9252 21.921 29.8799L21.7911 29.8591C20.994 29.732 20.4474 29.6449 19.9899 29.4245C19.0953 28.9937 18.4239 28.1982 18.1431 27.2364C18.0247 26.8309 18.004 26.3788 18.0006 25.7747L18 25.5803V20.124Z",
    fill: "url(#paint1_linear_4134_27427)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M27.9999 13.75C28.4142 13.75 28.7499 14.0858 28.7499 14.5L28.7499 19.5C28.7499 19.9142 28.4142 20.25 27.9999 20.25C27.5857 20.25 27.2499 19.9142 27.2499 19.5L27.2499 14.5C27.2499 14.0858 27.5857 13.75 27.9999 13.75Z",
    fill: "url(#paint2_linear_4134_27427)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M30.9999 15.25C31.4142 15.25 31.7499 15.5858 31.7499 16V18C31.7499 18.4142 31.4142 18.75 30.9999 18.75C30.5857 18.75 30.2499 18.4142 30.2499 18V16C30.2499 15.5858 30.5857 15.25 30.9999 15.25Z",
    fill: "url(#paint3_linear_4134_27427)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M24.9999 15.25C25.4142 15.25 25.7499 15.5858 25.7499 16L25.7499 18C25.7499 18.4142 25.4142 18.75 24.9999 18.75C24.5857 18.75 24.2499 18.4142 24.2499 18L24.2499 16C24.2499 15.5858 24.5857 15.25 24.9999 15.25Z",
    fill: "url(#paint4_linear_4134_27427)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_4134_27427",
    x1: 4.38384,
    y1: -7.55556,
    x2: 4.38383,
    y2: 56.4444,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8092e4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#38499b"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_4134_27427",
    x1: 19.5657,
    y1: 6.22222,
    x2: 19.5656,
    y2: 38.2222,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8092e4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#38499b"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_4134_27427",
    x1: 19.5657,
    y1: 6.22222,
    x2: 19.5656,
    y2: 38.2222,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8092e4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#38499b"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_4134_27427",
    x1: 19.5657,
    y1: 6.22222,
    x2: 19.5656,
    y2: 38.2222,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8092e4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#38499b"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_4134_27427",
    x1: 19.5657,
    y1: 6.22222,
    x2: 19.5656,
    y2: 38.2222,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8092e4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#38499b"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAudioEnabled);
export default __webpack_public_path__ + "static/media/audio-enabled.f88e0de8699b305070a4bc059292feba.svg";
export { ForwardRef as ReactComponent };